import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as moment from 'moment';
import { Column, GridComponent, PageService, PdfExportProperties, PdfExportService, ToolbarItems, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-buttons';
import { Router } from '@angular/router';

@Component({
  selector: 'app-programmazione',
  templateUrl: './programmazione.component.html',
  styleUrls: ['./programmazione.component.css'],
  providers: [PdfExportService, ToolbarService, PageService],

})
export class ProgrammazioneComponent implements OnInit {
  @ViewChild('grid')  public grid?: GridComponent;
  listFields:any[]=[];
  toolbarOptions?: ToolbarItems[];
  dateformat:any=null;
  reportPdf:string='';
  pageTitle:string='';
  struttureList:any[]=[];
  dataList:any[]=[];
  editRecordUrl:string='';
  deleteRecordUrl:string='';
  sintesipasti:boolean=false;
  allaDataSel:Date=null;
  dallaDataSel:Date=null;
  isLoading=true; 
  struttura_id:number=0;
  
   constructor(
        private apiService: ApiService,
        private globalService: GlobalService,
        public router: Router,
        
   ) { }

  ngOnInit(): void {
   this.dateformat = { type: 'date', format: "d/M/y" };
    this.toolbarOptions = ['PdfExport'];
    this.dallaDataSel=new Date();
    this.allaDataSel=new Date();
  //  this.allaDataSel.setDate(this.dallaDataSel.getDate() - 30);
    this.apiService.get('mensa/getstrutture',{}).subscribe((data)=>{
      this.struttureList=data.Result;
      if(this.globalService.loggedUser.struttura_id){
        this.struttura_id=this.globalService.loggedUser.struttura_id;
       
      } else {
        this.struttura_id=JSON.parse(localStorage.getItem('mensa_struttura_id'));
      
      }
      if(!this.struttura_id && this.struttureList.length>0){
        this.struttura_id=this.struttureList[0].value;
      }
      if(this.struttura_id){ 
       
        let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
        this.pageTitle=f[0].text;
        this.editRecordUrl='dashboard/gestionemensa/programmazione/programmazione-edit/update/'+f[0].text+'/'+this.struttura_id+'/';
        this.deleteRecordUrl='dashboard/gestionemensa/programmazione/programmazione-edit/delete/'+f[0].text+'/'+this.struttura_id+'/';
        localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
         this.changeStruttura({value:this.struttura_id});
        
      }
      this.loadData();
    });

  
    
  
    
  }

  newMenu(){
    let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
    this.editRecordUrl='dashboard/gestionemensa/programmazione/programmazione-edit/new/'+f[0].text+'/'+this.struttura_id+'/';
    this.router.navigate([this.editRecordUrl]);
  }

  loadData(){
    this.isLoading=true;
      let  listParams:any={
        struttura_id:this.struttura_id,

      };
      if(this.allaDataSel) {
        listParams.allaDataSel=moment(this.allaDataSel).format('YYYY-MM-DD');
      }
      if(this.dallaDataSel) {
        listParams.dallaDataSel=moment(this.dallaDataSel).format('YYYY-MM-DD');
      }
   
      

     this.apiService.get('mensa/mensa_programmazione_getall',listParams).subscribe((data)=>{
      this.dataList=data.Result;
      this.isLoading=false;
     });
    
     
  }

   toolbarClick(args: any): void {
        let pdfExportProperties: PdfExportProperties = {
          header: {
            fromTop: 0,
            height: 130,
            contents: [
            
              {
                type: 'Text',
                value: 'Menù programmato '+this.pageTitle+' '+moment(this.dallaDataSel).format('d/M/y')+ ' '+moment(this.allaDataSel).format('d/M/y'),
                position: { x:20, y: 50 },
                style: { textBrushColor: '#000000', fontSize: 20 },
              },
            ],
          }
        };
        if (args.item.id === 'Grid_pdfexport') {
           ((this.grid as GridComponent).columns[0] as Column).visible = false;
           ((this.grid as GridComponent).columns[4] as Column).visible = false;
           ((this.grid as GridComponent).columns[5] as Column).visible = false;
            (this.grid as GridComponent).showSpinner();
            (this.grid as GridComponent).pdfExport(pdfExportProperties);
        } 
    }

    pdfExportComplete(): void {
        (this.grid as GridComponent).hideSpinner();
        ((this.grid as GridComponent).columns[0] as Column).visible = true;
        ((this.grid as GridComponent).columns[4] as Column).visible = true;
        ((this.grid as GridComponent).columns[5] as Column).visible = true;
    }

  userCannotChangeStruttura(){
     if(this.globalService.loggedUser.struttura_id){
      return true;
     } else {
      return false;
     }
  }

  changeStruttura(event=null){
    if(event){
      this.struttura_id=event.value;
    }

    localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
    if(!this.isLoading){
      window.location.reload();
    }
    
  }

  cancella(row:any){

  }

  edit(row:any){
    console.log(row);
    this.router.navigateByUrl(this.editRecordUrl+row.id);
  }

}
